module.exports = __webpack_public_path__ + "img/Cost-of-Website-Development.9d18315d.png";